const pressList = {
	
	ui: {},

	init: function() {
		const allPressList = document.querySelectorAll('.js-pressList');

		allPressList.forEach(pressList => {
			const filter = pressList.querySelector('.js-pressList-filter');

			this.filterList(filter, pressList);

			filter.addEventListener('change', () => {
				this.filterList(filter, pressList);
			});
		});
	},

	filterList: function(filter, pressList) {
		const pressCards = pressList.querySelectorAll('.js-pressList-pressCard');

		const selectedYear = filter.value;
		pressCards.forEach(card => {
			if (card.getAttribute('data-year') === selectedYear) {
				card.classList.remove('--hidden');
			} else {
				card.classList.add('--hidden');
			}
		});

		this.countPressCards(pressList);
	},

	countPressCards: function(pressList) {
		const counter = pressList.querySelector('.js-pressList-count');
		const visiblePressCards = pressList.querySelectorAll('.js-pressList-pressCard:not(.--hidden)');
		counter.innerHTML = `(${visiblePressCards.length})`;
	}
};

module.exports = pressList;